import { useMemo } from "react"
import { type TMultiSelectOption } from "~/ui-rtk/components/ui/controls/MultiSelect"
import useProductHandleOptions from "~/ui-rtk/hooks/product-handle-options"

/**
 * Provides the `getSelectOptions` resolver consumed by TableFiltersBar for the
 * creative report's additional (non-column) searchable-select filters.
 *
 * The resolver switches on the BARE column key (TableFiltersBar passes the
 * unqualified `additionalFilters` value).
 */
export function useSelectFilterOptions() {
  const { productOptions, isLoading } = useProductHandleOptions()

  const getSelectOptions = useMemo(
    () =>
      (columnKey: string): TMultiSelectOption[] => {
        switch (columnKey) {
          case "all_product_handles_str":
            return productOptions
          default:
            return []
        }
      },
    [productOptions],
  )

  return {
    getSelectOptions,
    isLoading,
  }
}

export default useSelectFilterOptions
